import { render, staticRenderFns } from "./StudentstatisticsSubordinateUnits.vue?vue&type=template&id=13aa8fb3"
import script from "./StudentstatisticsSubordinateUnits.vue?vue&type=script&lang=js"
export * from "./StudentstatisticsSubordinateUnits.vue?vue&type=script&lang=js"
import style0 from "./StudentstatisticsSubordinateUnits.vue?vue&type=style&index=0&id=13aa8fb3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports